import { Action } from '@ngrx/store';

import { CourseReserve } from '®shared/list-item/course-reserve';
import { ListItem } from '®shared/reading-list';

export enum RequestCourseReserveModalActionTypes {
  REQUEST_COURSE_RESERVE = '[Request course reserve modal] Request course reserve',
  REQUEST_COURSE_RESERVE_SUCCESS = '[Request course reserve modal] Request course reserve success',
  REQUEST_COURSE_RESERVE_FAILED = '[Request course reserve modal] Request course reserve failed',
  SHOW_REQUEST_COURSE_RESERVE_MODAL = '[Request course reserve modal] Show request course reserve modal',
  HIDE_REQUEST_COURSE_RESERVE_MODAL = '[Request course reserve modal] Hide request course reserve modal',
}

export interface ItemPayload {
  item: ListItem;
}

export class RequestCourseReserveAction implements Action {
  readonly type = RequestCourseReserveModalActionTypes.REQUEST_COURSE_RESERVE;

  constructor(public payload: { courseReserve: CourseReserve }) {}
}

export class RequestCourseReserveSuccessAction implements Action {
  readonly type =
    RequestCourseReserveModalActionTypes.REQUEST_COURSE_RESERVE_SUCCESS;

  constructor(
    public payload: { courseReserveId: string; listItemId: string },
  ) {}
}

export class RequestCourseReserveFailedAction implements Action {
  readonly type =
    RequestCourseReserveModalActionTypes.REQUEST_COURSE_RESERVE_FAILED;

  constructor(public payload: { error: Error }) {}
}

export class ShowRequestCourseReserveModalAction implements Action {
  readonly type =
    RequestCourseReserveModalActionTypes.SHOW_REQUEST_COURSE_RESERVE_MODAL;

  constructor(public payload: ItemPayload) {}
}

export class HideRequestCourseReserveModalAction implements Action {
  readonly type =
    RequestCourseReserveModalActionTypes.HIDE_REQUEST_COURSE_RESERVE_MODAL;

  constructor() {}
}

export type RequestCourseReserveModalActions =
  | RequestCourseReserveAction
  | RequestCourseReserveSuccessAction
  | RequestCourseReserveFailedAction
  | ShowRequestCourseReserveModalAction
  | HideRequestCourseReserveModalAction;
